import { supertypeClass, property, Persistable, Supertype } from '@haventech/amorphic';

import { Persistent } from '@hit/amorphic-types';

@supertypeClass({ toClient: true, toServer: false })
export class ManagedEntityType extends Persistable(Supertype) {
  @property({
    toServer: false,
    toClient: false,
  })
  templateName: string;

  private constructor() {
    super();
  }

  static new(templateName: string): ManagedEntityType {
    return new ManagedEntityType().init(templateName);
  }

  private init(templateName: string): ManagedEntityType {
    this.templateName = templateName;

    return this;
  }
}
